import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import blogPosts from '../../data/blogPosts';
import VenuesBanner from '../VenuesBanner/VenuesBanner';
import './Blog.css';

const BLOG_AUTHOR_AVATARS = {
  'Priyanka Roychoudhury': '/pori.png',
  'Hrishikesh Sarma': '/dugi.png',
  'Occasia Team': '/occasia.svg',
};

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((item) => item.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return (
      <div className="blog-container">
        <div className="blog-inner">
        <div className="blog-not-found">
          <h1>Article not found</h1>
          <p>The story you are looking for has moved or never existed.</p>
          <Link to="/blog" className="blog-card-link">
            Back to all articles
          </Link>
        </div>
        </div>
      </div>
    );
  }

  return (
    <article className="blog-article">
      <div className="blog-inner">
      <header className="blog-article-hero">
        <Link to="/blog" className="blog-article-back">
          <img src="/manual-booking/icons/arrow-left.svg" alt="" aria-hidden />
          Back to all articles
        </Link>
        <div className="blog-article-tags">
          {post.tags.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
        <h1 className="blog-article-title">{post.title}</h1>
        <div className="blog-article-meta">
          <div className="blog-article-avatar-wrap">
            <img
              className="blog-article-avatar"
              src={BLOG_AUTHOR_AVATARS[post.author] || '/occasia.svg'}
              alt=""
            />
          </div>
          <div className="blog-article-meta-copy">
            <span className="blog-article-author">{post.author}</span>
            <span className="blog-article-meta-details">
              {new Date(post.date).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}
              {' · '}
              {post.readTime}
            </span>
          </div>
        </div>
        <div className="blog-article-hero-image">
          <img src={post.heroImage} alt={post.title} loading="lazy" />
        </div>
      </header>

      <div className="blog-article-body">
        {post.intro && <p className="blog-article-intro">{post.intro}</p>}

        {post.sections.map((section) => (
          <section key={section.heading} className="blog-article-section">
            <h2>{section.heading}</h2>
            {section.paragraphs &&
              section.paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            {section.listTitle && <h3 className="blog-article-list-title">{section.listTitle}</h3>}
            {section.listItems && (
              <ul>
                {section.listItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            )}
            {section.paragraphs2 &&
              section.paragraphs2.map((paragraph, index) => (
                <p key={`extra-${index}`}>{paragraph}</p>
              ))}
          </section>
        ))}

        {post.quote && (
          <blockquote className="blog-article-quote">
            <p>“{post.quote.text}”</p>
            <span>{post.quote.author}</span>
          </blockquote>
        )}

        {post.closing && <p className="blog-article-closing">{post.closing}</p>}

        <VenuesBanner />
      </div>
      </div>
    </article>
  );
};

export default BlogPost;

